export default {
  name: "CalendarCancel",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 5h-4V3c0-.55-.45-1-1-1s-1 .45-1 1v2H10V3c0-.55-.45-1-1-1s-1 .45-1 1v2H4c-1.16 0-2 .84-2 2v21c0 1.16.84 2 2 2h24c1.16 0 2-.84 2-2V7c0-1.16-.84-2-2-2zm0 23H4V7h4v1c0 .55.45 1 1 1s1-.45 1-1V7h12v1c0 .55.45 1 1 1s1-.45 1-1V7h4v21zm-7.04-13.54L17.41 18l3.54 3.54a.996.996 0 0 1-.71 1.7c-.26 0-.51-.1-.71-.29L16 19.41l-3.54 3.54c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41L14.59 18l-3.54-3.54a.996.996 0 1 1 1.41-1.41L16 16.59l3.54-3.54c.39-.39 1.02-.39 1.41 0s.4 1.02.01 1.41z",
  },
}
